import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from './container/Home';
import Challenges from './container/Challenges';
import AboutPage from './container/About';
import ContactPage from './container/Contact';
import ItineryDetails from './container/ItineraryDetails';
import PrivacyPage from './container/PrivacyPolicy';
import TermsAndCondi from './container/TermsAndCondi';
import BlogPage from './container/Blog';
import { ThemeProvider } from "./Context/Theme/Context"
import ScrollToTop from './components/ScrollToTop';
import BlogDetails from './container/BlogDetails';
import BlogList from './container/Blog';
import { ToastContainer } from 'react-toastify';

function App() {
  const isAuthenticated = true

  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <ScrollToTop path={window.location.pathname} />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/explore/:title" element={<Challenges />} />
            <Route path="/explore/:category/:title" element={<ItineryDetails />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            {/* <Route path="/privacy" element={<PrivacyPage />} />   */}
            {/* <Route path="/terms-and-condition" element={<TermsAndCondi />} />   */}
            {/* <Route path="/contact" element={<ContactPage />} />  */}
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/cms/:title" element={<BlogDetails />} />
            <Route path="/blog/:title" element={<BlogDetails />} />
          </Routes>
          <ToastContainer></ToastContainer>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
